import {
  jb_picture_css_default
} from "./chunk.EHOPBIDR.js";
import {
  o
} from "./chunk.BLBOUOUQ.js";
import {
  LazyLoadingHandler_default
} from "./chunk.ZXFS3F4J.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-picture/jb-picture.ts
var JbPicture = class extends i {
  constructor() {
    super(...arguments);
    this.fit = "fill";
    this.lazy = false;
  }
  firstUpdated() {
    if (!this.lazy) {
      return;
    }
    if (document.readyState === "complete") {
      this._initLazyLoading();
    } else {
      window.addEventListener("load", () => {
        this._initLazyLoading();
      });
    }
    window.addEventListener("beforeprint", () => {
      this.lazy = false;
    });
  }
  _getSrcset(source) {
    const res = [];
    source.srcsets.forEach((srcset) => {
      res.push(`${srcset.uri} ${srcset.pixelDensity}x`);
    });
    return res.join(", ");
  }
  _initLazyLoading() {
    LazyLoadingHandler_default.observe(this._lazyImage, this._loadImage, "approachingViewport");
    this._lazyImage.addEventListener("load", () => {
      this.dispatchEvent(new CustomEvent("load", { bubbles: true, composed: true }));
    });
  }
  _loadImage(el) {
    if (!el.hasAttribute("data-lazy-src")) return;
    const pic = el.closest("picture");
    if (pic) {
      pic.querySelectorAll("source[data-lazy-srcset]").forEach((source) => {
        source.setAttribute("srcset", source.getAttribute("data-lazy-srcset") || "");
        source.removeAttribute("data-lazy-srcset");
      });
    }
    el.setAttribute("src", el.getAttribute("data-lazy-src") || "");
    el.removeAttribute("data-lazy-src");
  }
  _renderSources() {
    if (!this.imgData.sources) {
      return null;
    }
    if (this.lazy) {
      return Object.values(this.imgData.sources).map(
        (source) => b`
          <source
            srcset=""
            data-lazy-srcset="${this._getSrcset(source)}"
            media="${source.mediaQuery}"
            type="${o(source.type)}"
          />
        `
      );
    }
    return Object.values(this.imgData.sources).map(
      (source) => b`
        <source
          srcset="${this._getSrcset(source)}"
          media="${source.mediaQuery}"
          type="${o(source.type)}"
        />
      `
    );
  }
  render() {
    return b`
      <picture
        class=${e2({
      [`${this.fit}`]: true,
      [`${this.aspect}`]: !!this.aspect
    })}
        part="picture"
      >
        ${this._renderSources()}
        <img
          src="${this.lazy ? "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" : this.imgData.fallbackImage.src}"
          data-lazy-src="${o(this.lazy ? this.imgData.fallbackImage.src : void 0)}"
          height="${o(this.imgData.fallbackImage.dimensions?.height)}"
          width="${o(this.imgData.fallbackImage.dimensions?.width)}"
          alt="${this.alt || ""}"
          @load=${() => this.dispatchEvent(new CustomEvent("jb-picture:load", { bubbles: true, composed: true }))}
        />
      </picture>
    `;
  }
};
JbPicture.styles = [reset_css_default, jb_picture_css_default];
__decorateClass([
  n()
], JbPicture.prototype, "alt", 2);
__decorateClass([
  n()
], JbPicture.prototype, "aspect", 2);
__decorateClass([
  n()
], JbPicture.prototype, "fit", 2);
__decorateClass([
  n({ type: Object })
], JbPicture.prototype, "imgData", 2);
__decorateClass([
  n({ type: Boolean })
], JbPicture.prototype, "lazy", 2);
__decorateClass([
  e("img[data-lazy-src]")
], JbPicture.prototype, "_lazyImage", 2);
JbPicture = __decorateClass([
  customElement("jb-picture")
], JbPicture);

export {
  JbPicture
};
